/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unneeded-ternary */
/**
 * Module for header on InventoryRequestDetailCatalog Page
 * @module src/SurgicalDetail/InventoryRequestDetailCatalog
 */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { FC, ReactNode, useCallback, useEffect, useState } from 'react';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import { useLazyQuery, useMutation, useQuery } from '@apollo/react-hooks';
import { debounce } from 'lodash';
import Input from '@salesforce/design-system-react/components/input';
import Combobox from '@salesforce/design-system-react/components/combobox';
import PageHeader from '@salesforce/design-system-react/components/page-header';
import PageHeaderControl from '@salesforce/design-system-react/components/page-header/control';
import ButtonGroup from '@salesforce/design-system-react/components/button-group';
import Button from '@salesforce/design-system-react/components/button';
import Spinner from '@salesforce/design-system-react/components/spinner';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import Icon from '@salesforce/design-system-react/components/icon';
import { getUserInfo } from '../../../../store/ducks/userInfo';
import CartComponent from './cartComponent';
import './index.scss';
import EventStatusBadge from '../../../Shared/EventStatusBadge';
import { CYCLE_COUNT,
  MAX_QUANTITY,
  NOTIFY_TYPE,
  OPSCSRUSERS,
  ORDER_TYPE,
  PERSONAS_SALES_RESP, STALE_RECORD_MESSAGE, 
  SYSTEM_NAME,
  DEFAULT_VERSION} from '../../../../util/constants';
import { isStaleRecordError } from '../../../../util/optimisticLock';
import {
  getDateDifferenceInDays,
  getEventIcon,
  getHoldIcon,
  getSvgIcon,
  lotAccountFilter,
  maxQuantityCals,
} from '../../../../util/utilityFunctions';
import RESUBMIT_ORDER_DETAILS from '../../../../graphql/mutations/resubmitOrderDetails';
import CREATE_UPDATE_INVENTORY_RETURN_LINE_ITEMS from '../../../../graphql/mutations/createUpdateInventoryReturnLineItems';
import SnackBar from '../../../Shared/SnackBar';
import useSnackBar from '../../../../util/customHooks/useSnackBar';
import debounced from '../../../../util/debounced';
import { GET_INVENTORY_RETURN_DETAILS } from '../../../../graphql/getInventoryReturnDetails';
import { GET_ORDER_DETAILS } from '../../../../graphql/getOrderDetails';
import InputWithAutoSuggestion from '../../../Usage/UsageDetails/UsageTabs/Parts/InputWithAutoSuggestion';
import { GET_PARTS_WITH_LOT_DETAILS } from '../../../../graphql/getPartWithLotDetails';
import InventoryAddParts from '../AddPartsModal/InventoryAddParts';

interface Props {
  inventoryDetail?: any;
  isEventInventoryFlow?: boolean;
  refetch: () => void;
  visualIndicator: string;
  type: string;
  hasEventInventory?: any;
  eventInventoryExternalId?: any;
  externalId?: any;
  isOrder?: boolean;
  detailsViewConfig?: any;
  returnType?: any;
  viewOnly?: boolean;
}

interface DynamicValue {
  [key: string]: any;
}

interface SelectedData {
  id: string;
  value: string;
  __typename?: string;
}

const InventoryRequestTable: FC<Props> = ({
  refetch,
  inventoryDetail,
  isEventInventoryFlow,
  visualIndicator,
  type,
  hasEventInventory,
  eventInventoryExternalId,
  externalId,
  isOrder,
  detailsViewConfig,
  returnType,
  viewOnly,
}) => {
  const userInfo = useSelector(getUserInfo);
  const { open, notification, openSnackBar } = useSnackBar();
  const [searchValue, setSearchText] = useState('');
  const [isLoading, setLoader] = useState(false);
  const [showSearchCatalogModal, setShowSearchCatalogModal] = useState(false);
  const [onChangeActive, setonChangeActive] = useState(false);
  const [items, setItems] = useState<any>([]);
  const [lotChange, setLotChange] = useState<any>([]);
  const [selectedFilter, setSelectedFilter] = useState<DynamicValue | null>(null);
  const [, setSelectedFilterApiValues] = useState<DynamicValue | null>(null);
  const [reSubmitInventory] = useMutation(RESUBMIT_ORDER_DETAILS);
  const [
    createUpdateInventoryReturn,
    { data: createUpdateInventoryReturnMutation, loading: updateLoader },
  ] = useMutation(CREATE_UPDATE_INVENTORY_RETURN_LINE_ITEMS);
  const isUserOpsCsr = !!OPSCSRUSERS?.find((rec: any) => rec?.value === userInfo?.personas);
  const isUserSalesRep = userInfo?.personas === PERSONAS_SALES_RESP;
  const [getPartsLotDetails, { data: partsLotDetails, loading: partsLoader }] = useLazyQuery(
    GET_PARTS_WITH_LOT_DETAILS,
    {
      fetchPolicy: 'no-cache',
    }
  );

  const { data: getInventoryRequestDetails, refetch: refetchEventDetails, loading } = useQuery(
    GET_INVENTORY_RETURN_DETAILS,
    {
      fetchPolicy: 'no-cache',
      variables: {
        id: externalId,
      },
    }
  );

  const {
    data: getOrderDetails,
    refetch: refetchProcessedEventDetails,
    loading: processedLoading,
  } = useQuery(GET_ORDER_DETAILS, {
    fetchPolicy: 'no-cache',
    variables: {
      id: externalId,
      searchText: searchValue,
    },
  });
  const onHandleCloseSearchCatalogModal = (): void => {
    setShowSearchCatalogModal(false);
    if (refetch) {
      refetch();
    }
  };
  const tableClass =
    returnType === 'Failed' || returnType === 'Completed'
      ? inventoryDetail.orderType === 'Pickup Return'
        ? 'irpp-cols'
        : 'irs-cols'
      : inventoryDetail.returnType === 'Pickup Return'
      ? 'irpp-cols'
      : 'irs-cols';
  const isPickupReturnType =
    returnType === 'Failed' || returnType === 'Completed'
      ? inventoryDetail.orderType === 'Pickup Return'
      : inventoryDetail?.returnType !== 'Inventory Return';
  const isUserOps =
    !!userInfo?.personas?.toLowerCase().includes('branch op') ||
    userInfo?.personas === 'CSR;Branch Op' ||
    userInfo?.personas === '3PL Ops';

  const [quantityRecCount, setCartRecCount] = useState(
    inventoryDetail?.receivedLineItems?.reduce(
      (
        accumulator: any,
        current: {
          receivedQuantity: any;
          quantity: any;
        }
      ) => accumulator + Number(current?.receivedQuantity),
      0
    )
  );
  const [quantityCount, setCartCount] = useState(
    inventoryDetail?.lineItems?.reduce(
      (accumulator: any, current: { quantity: any }) => accumulator + Number(current.quantity),
      0
    )
  );
  let enabledTabs: any[] = [];
  if (detailsViewConfig) {
    detailsViewConfig.forEach((item: any) => {
      if (item.isShow === true) {
        enabledTabs = [...enabledTabs, item.mappingKey];
      }
    });
  }
  useEffect(() => {
    if (type === 'Returning') {
      const total = items?.reduce(
        (accumulator: any, current: any) => accumulator + Number(current.counterValue),
        0
      );
      setCartCount(total);
    } else {
      const total = items?.reduce(
        (accumulator: any, current: any) => accumulator + Number(current.counterValue),
        0
      );
      setCartRecCount(total);
    }
  }, [items, type]);

  useEffect(() => {
    const { lineItems } = inventoryDetail;
    if (
      lineItems &&
      lineItems.length > 0 &&
      (inventoryDetail?.accountName || inventoryDetail?.accountNumber)
    ) {
      getPartsLotDetails({
        variables: {
          productNumber: lineItems.map((i: any) => {
            return { productNumber: i.productNumber, sourceLocation: i.sourceLocation };
          }),
          subInventoryName: inventoryDetail?.accountName,
          accountNumber: inventoryDetail?.accountNumber,
          salesRepId: inventoryDetail?.salesRepId,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inventoryDetail]);

  const removeDuplicates = (array: any): any => {
    const newArray: any[] = [];
    const duplicateLots: any[] = [];
    array.forEach((item: any) => {
      const records = array.filter((x: any) => x?.lotNumber === item?.lotNumber);
      if (records?.length === 1) {
        newArray.push(item);
      } else if (records?.length > 1 && duplicateLots.indexOf(item?.lotNumber) === -1) {
        const subInventoryTypes = ['IT', 'IH', 'E'];
        // eslint-disable-next-line no-restricted-syntax
        for (const types of subInventoryTypes) {
          const foundInventory = records.find(
            (ele: any) =>
              ele?.caseUsageSubInventoryCode?.startsWith(types) ||
              ele?.subInventoryCode?.startsWith(types)
          );
          if (foundInventory && Number(foundInventory.availableqty) > 0) {
            newArray.push(foundInventory);
            duplicateLots.push(item.lotNumber);
            break;
          }
        }
      }
      return null;
    });

    return newArray;
  };

  useEffect(() => {
    if (partsLotDetails?.getPartWithLotDetails) {
      setLoader(true);
      const lotOptionsValues = partsLotDetails.getPartWithLotDetails;
      // lotvalues should be account specific for returns
      const lotDetails = lotAccountFilter(
        inventoryDetail?.type,
        lotOptionsValues,
        inventoryDetail?.accountNumber
      );
      const lotOptions: any = [];
      lotDetails?.forEach((item: any) => {
        let dDiff = 60;
        dDiff = getDateDifferenceInDays(item.expirationDate, new Date().toString());

        const data = {
          ...item,
          label: item.lotNumber,
          value: item.lotNumber,
          expiresInDays: item.expirationDate ? dDiff : 60,
        };
        const findSelectedLot = items.find((itm: any) => itm.lotNumber === item.lotNumber);
        if (Number(item.availableqty) > 0 || findSelectedLot?.lotNumber) {
          lotOptions.push(data);
        }
      });
      const lineItems = items.map((i: any) => {
        const isLotExist = lotOptions?.find(
          (element: any) =>
            (element.lotNumber === i.lotNumber && Number(i.quantity) > 0 && !i.iscatalog) ||
            (inventoryDetail?.status === 'Failed' &&
              element.lotNumber === i.lotNumber &&
              Number(i.quantity) > 0)
        );

        const alreadyAddedLot = lotDetails?.find(
          (element: any) =>
            (element.lotNumber === i.lotNumber && Number(i.quantity) > 0 && !i.iscatalog) ||
            (inventoryDetail?.status === 'Failed' &&
              element.lotNumber === i.lotNumber &&
              Number(i.quantity) > 0)
        );
        if (
          (alreadyAddedLot && !isLotExist && !i.iscatalog) ||
          (inventoryDetail?.status === 'Failed' && alreadyAddedLot && !isLotExist)
        ) {
          const dDiff = getDateDifferenceInDays(
            alreadyAddedLot.expirationDate,
            new Date().toString()
          );

          const data = {
            ...alreadyAddedLot,
            label: alreadyAddedLot.lotNumber,
            value: alreadyAddedLot.lotNumber,
            expiresInDays: alreadyAddedLot.expirationDate ? dDiff : 60,
          };
          lotOptions.push(data);
        } else if (
          (!alreadyAddedLot && i.lotNumber && i.isValidLotSerialCombination && !i.iscatalog) ||
          (!alreadyAddedLot &&
            i.lotNumber &&
            i.isValidLotSerialCombination &&
            inventoryDetail?.status === 'Failed')
        ) {
          lotOptions.push({
            availableqty: i.availableQuantity,
            expirationDate: i.expirationDate,
            lotNumber: i.lotNumber,
            onhandqty: i.onhandQuantity,
            productDescription: i.productdescription,
            productNumber: i.productNumber,
            sourceLocation: i.sourceLocation,
            label: i.lotNumber,
            value: i.lotNumber,
            caseUsageSubInventoryCode: i.caseUsageSubInventoryCode,
            subInventoryCode: i.caseUsageSubInventoryCode,
          });
        }

        const lotValues = removeDuplicates(
          !i.iscatalog || inventoryDetail?.status === 'Failed'
            ? lotOptions.filter(
                (item: any) =>
                  item?.productNumber === i?.productNumber &&
                  item?.sourceLocation === i.sourceLocation
              )
            : lotOptions.filter(
                (item: any) =>
                  item?.productNumber === i?.productNumber &&
                  Number(item.availableqty) > 0 &&
                  item?.sourceLocation === i.sourceLocation
              )
        );

        const maxQuantity = i.lotNumber
          ? Number(i.availableQuantity) + Number(i.quantity)
          : MAX_QUANTITY;
        let isERPOrder = false;
        if (
          type &&
          (type === 'Failed' || type === 'Processed' || type === 'Review') &&
          inventoryDetail?.orderId
        ) {
          isERPOrder = true;
        }
        return {
          ...i,
          uniqueId: isERPOrder ? i.caseUsageExternalId || i.sfid || i.externalId : i.externalId,
          originalQty: i.quantity,
          maxQuantity,
          lotOptions: lotValues,
          selectedLot: lotValues.filter((item: any) => item.lotNumber === i.lotNumber),
        };
      });
      const newLineItems = lineItems?.map((i: any) => {
        const opt = i?.lotOptions?.filter(
          (lot: any) =>
            (Number(lot.availableqty) === 0 && lot.lotNumber === i.lotNumber) ||
            Number(lot.availableqty) > 0
        );
        return {
          ...i,
          lotOptions: opt,
        };
      });
      setItems(newLineItems);
      setTimeout(() => {
        setLoader(false);
      }, 4000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partsLotDetails, refetch]);

  useEffect(() => {
    if (type === 'Returning') {
      const updateList = inventoryDetail.lineItems.map((record: any) => {
        return {
          ...record,
          changed: false,
          counterValue: Number(record.quantity),
        };
      });
      setItems(updateList);
    } else {
      const updateList = inventoryDetail.receivedLineItems.map((record: any) => {
        return {
          ...record,
          changed: false,
          counterValue: Number(record?.receivedQuantity),
        };
      });
      setItems(updateList);
    }
    // setLoader(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inventoryDetail.lineItems, type, inventoryDetail.receivedLineItems]);

  const calculateActualQuantitity = useCallback((item: any, onHandQuantity: any) => {
    const isPackContent = item?.salesUnitOfMeasure === 'PK' || item?.salesUnitOfMeasure === 'BX';
    if (!isPackContent) {
      return onHandQuantity;
    }
    const packOfContentCount = item?.packContent > 0 ? item?.packContent || 1 : 1;
    if (item?.productFamily === 'SPTSIMPLANTS') {
      return onHandQuantity * packOfContentCount;
    }
    return onHandQuantity;
  }, []);
  const holdIconPath = getHoldIcon();
  const catalogInd = getSvgIcon('catalog');
  const formatLineItemToReSubmit = (lineItemsArray: any): any => {
    const finalLineItems: Array<any> = [];
    lineItemsArray.map(
      (item: {
        isLotNumber: any;
        productId: any;
        productNumber: any;
        quantity: any;
        actualQuantity: any;
        externalId: any;
        lotNumber: any;
        sfid: any;
        unitPrice: any;
        caseUsageExternalId: any;
        priceBookEntryId: any;
        salesUnitOfMeasure: any;
        deliveredDate: any;
        caseUsageId: any;
        returnReason: any;
        sourceLocation: any;
        returnType: any;
        trackingNumber: any;
        // eslint-disable-next-line array-callback-return
      }): any => {
        finalLineItems.push({
          caseUsageId: item.caseUsageId,
          caseUsageExternalId: item.caseUsageExternalId,
          priceBookEntryId: item.priceBookEntryId,
          salesUnitOfMeasure: item.salesUnitOfMeasure,
          deliveredDate: item.deliveredDate || null,
          productId: item.productId,
          productNumber: item.productNumber,
          quantity: item.quantity,
          actualQuantity: item.actualQuantity,
          isLotNumber: item?.isLotNumber,
          lotNumber: item.lotNumber || '',
          externalId: item.externalId || null,
          sfid: item.sfid || '',
          unitPrice: item.unitPrice || '',
          returnReason: item.returnReason || null,
          sourceLocation: item.sourceLocation,
          returnType: item.returnType,
          trackingNumber: item.trackingNumber || '',
        });
      }
    );
    return finalLineItems;
  };

  const handleUpdates = (lotValCase = false): void => {
    setLoader(true);
    if (returnType === 'Failed') {
      // resubmitInventory();
      const payload: Array<any> = [];
      items.forEach((product: any): void => {
        if (product.changed) {
          const actualQuantity = calculateActualQuantitity(product, product.counterValue);
          payload.push({
            sfid: product.sfid,
            externalId: product.externalId,
            productId: product.productId,
            quantity: product.counterValue.toString(),
            actualQuantity: actualQuantity.toString(),
            productNumber: product.productNumber,
            priceBookEntryId: product.priceBookEntryId,
            salesUnitOfMeasure: product.salesUnitOfMeasure,
            sourceLocation: product.sourceLocation,
            lotNumber: product.lotNumber,
            isLotNumber: product?.isLotNumber,
            trackingNumber: product.trackingNumber,
            returnType: product.returnType,
            returnReason: product.returnReason
              ? typeof product.returnReason === 'string'
                ? product.returnReason
                : product.returnReason[0].value
              : null,
            deliveredDate: null,
            ...(product.usageExternalId && { usageExternalId: product.usageExternalId }),
            ...(product.caseUsageId && { caseUsageId: product.caseUsageId }),
            ...(product.caseUsageExternalId && {
              caseUsageExternalId: product.caseUsageExternalId,
            }),
          });
        }
      });
      const mutation = {
        id: inventoryDetail.id,
        caseId: inventoryDetail.caseId,
        caseExternalId: inventoryDetail.caseExternalId,
        // comments: userComment,
        submitType: 'Update',
        lineItems: formatLineItemToReSubmit(payload),
        salesRepId: inventoryDetail.salesRepId,
        expectedCaseVersion: inventoryDetail.caseVersion,
      };

      setLoader(true);
      reSubmitInventory({
        variables: mutation,
      })
        .then((res: any) => {
          if (res && res.data && res.data.resubmitOrderDetails?.message === NOTIFY_TYPE.SUCCESS) {
            if (!lotValCase) {
              setTimeout(() => {
                setLoader(false);
                openSnackBar(
                  NOTIFY_TYPE.SUCCESS,
                  'Line items for Return Inventory updated successfully'
                );
              }, 2500);
            }
            refetch();
          }
        })
        .catch(error => {
          setLoader(false);
          if (isStaleRecordError(error)) {
            openSnackBar(NOTIFY_TYPE.ERROR, STALE_RECORD_MESSAGE);
          } else if (error && error.message) {
            setLoader(false);
            openSnackBar(NOTIFY_TYPE.ERROR, `${error.message}`);
          } else openSnackBar(NOTIFY_TYPE.ERROR, 'Error: Inventory Return error.');
          // eslint-disable-next-line no-console
          console.log('We had a trouble saving data to salesforce. Please try again later');
          // eslint-disable-next-line no-console
          console.log(error); // TODO change when some operation needs to be run on error.
        });
    } else {
      const payload: Array<any> = [];
      items?.forEach((product: any): void => {
        if (product.changed || product.uniqueId || lotValCase) {
          const actualQuantity = calculateActualQuantitity(product, product.counterValue);
          payload.push({
            productId: product.productId,
            externalId: product.externalId,
            id: product?.id,
            sourceLocation: product?.sourceLocation,
            returnReason: product.returnReason
              ? typeof product.returnReason === 'string'
                ? product.returnReason
                : product.returnReason[0].value
              : null,
            trackingNumber: product.trackingNumber,
            subInventoryCode: product?.caseUsageSubInventoryCode || '',
            quantity: product.counterValue.toString(),
            productNumber: product.productNumber,
            lotNumber: product.lotNumber,
            isLotNumber: product?.isLotNumber,
            actualQuantity: actualQuantity.toString(),
            isLotValueUpdated: product?.isLotValueUpdated || false,
            isValidLotSerialCombination: product?.isValidLotSerialCombination,
            iscatalog: product?.iscatalog,
            previousLotNumber: product?.previousLotNumber || '',
            // previousQuantity: product?.previousQuantity || '',
            ...(product.usageExternalId && { usageExternalId: product.usageExternalId }),
          });
        }
      });

      let mutation: any = {
        orderId: inventoryDetail.orderId,
        orderExternalId: inventoryDetail.orderExternalId,
        salesRepId: inventoryDetail.salesRepId,
        formType: 'Update',
        // returnType: inventoryDetail.returnType,
      };
      if (type === 'Returning') {
        mutation = {
          ...mutation,
          lineItems: payload,
        };
      } else {
        mutation = {
          ...mutation,
          receivedLineItems: payload,
        };
      }
      mutation = {
        ...mutation,
        system: SYSTEM_NAME,
        version: process.env.REACT_APP_VERSION || DEFAULT_VERSION,
      }
      setLoader(true);
      createUpdateInventoryReturn({
        variables: {
          ...mutation,
          expectedCaseVersion: inventoryDetail?.caseVersion,
        },
      })
        .then((res: any) => {
          if (
            res &&
            res.data &&
            res.data.createUpdateInventoryReturnLineItems.message === 'success'
          ) {
            if (!lotValCase) {
              setTimeout(() => {
                // setLoader(false);
                openSnackBar(
                  NOTIFY_TYPE.SUCCESS,
                  'Line items for Return Inventory updated successfully'
                );
              }, 1000);
            }
            refetch();
          }
        })
        .catch(error => {
          /* Resync so a rejected change does not linger on screen. */
          if (isStaleRecordError(error)) {
            openSnackBar(NOTIFY_TYPE.ERROR, STALE_RECORD_MESSAGE);
            refetch();
            return;
          }
          setLoader(false);
          setTimeout(() => {
            if (error && error.message) {
              setLoader(false);
              openSnackBar(NOTIFY_TYPE.ERROR, `${error.message}`);
            } else {
              openSnackBar(
                NOTIFY_TYPE.ERROR,
                'Error:  We are having issue updating the line items for Return Inventory'
              );
            }
          }, 1000);
        });
    }
  };

  useEffect(() => {
    if (
      items?.length > 0 &&
      (inventoryDetail?.type === 'Pickup Return' ||
        inventoryDetail?.type === 'Inventory Return' ||
        inventoryDetail?.type === 'Standard Return') &&
      type !== 'Failed' &&
      type !== 'Processed' &&
      partsLotDetails?.getPartWithLotDetails?.length > 0
    ) {
      let isLotValueUpdated = false;
      items.forEach((i: any) => {
        const product: any = items?.find(
          (item: any) =>
            item.lotNumber === i.lotNumber &&
            item.productNumber === i.productNumber &&
            item.externalId !== i.externalId &&
            item.iscatalog &&
            item.sourceLocation === i.sourceLocation &&
            partsLotDetails?.getPartWithLotDetails?.length > 0
        );

        if (
          product &&
          i.isValidLotSerialCombination &&
          Number(i.availableQuantity) > 0 &&
          !product.isValidLotSerialCombination
        ) {
          product.caseUsageSubInventoryCode = i.caseUsageSubInventoryCode;
          product.isLotValueUpdated = true;
          isLotValueUpdated = true;
        } else {
          const lotOptions = partsLotDetails?.getPartWithLotDetails;
          const availableLots: any = lotOptions.filter(
            (item: any) =>
              item.lotNumber === i.lotNumber &&
              !i.isValidLotSerialCombination &&
              item.sourceLocation === i.sourceLocation &&
              i.iscatalog &&
              Number(item.availableqty) > 0 &&
              item.productNumber === i.productNumber
          );

          if (
            (!product &&
              i.iscatalog &&
              !i.isValidLotSerialCombination &&
              Number(i.availableQuantity) > 0) ||
            availableLots?.length > 0
          ) {
            // eslint-disable-next-line no-param-reassign
            i.isLotValueUpdated = true;
            isLotValueUpdated = true;
          }
        }
      });
      if (isLotValueUpdated && !onChangeActive) {
        if (items.length > 0 && inventoryDetail?.status !== 'Failed') {
          setItems(items || []);
          setTimeout(() => {
            handleUpdates(true);
          }, 2000);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);

  useEffect(() => {
    let delayDebounceFn: NodeJS.Timeout;
    if (lotChange === 1) {
      // // eslint-disable-next-line prefer-const
      delayDebounceFn = setTimeout(() => {
        handleUpdates();
      }, 2000);
      setLotChange(0);
    }
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    // return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, lotChange]);

  const getFilterApiValue = (filterValues: DynamicValue): DynamicValue => {
    let reducedFilterValues = {};
    if (filterValues) {
      Object.keys(filterValues).forEach((key: string) => {
        if (Array.isArray(filterValues[key])) {
          const values = filterValues[key].map((item: SelectedData) => item.value);
          if (values && values.length > 0) {
            reducedFilterValues = { ...reducedFilterValues, [key]: [...values] };
          }
        } else if (key !== '__typename' && filterValues[key]) {
          reducedFilterValues = { ...reducedFilterValues, [key]: filterValues[key] };
        }
      });
      const filterData = { ...reducedFilterValues };
      return filterData;
    }
    return {};
  };
  const handleFilter = (filterValues: DynamicValue | null, filterName?: string): void => {
    const updatedFilterName = filterName || '';
    const filter = {
      filterValues,
      filterName: updatedFilterName,
    };
    setSelectedFilter(filter);
    if (filterValues) {
      const filters = getFilterApiValue(filterValues);
      setSelectedFilterApiValues(filters);
    }
  };

  const handleAddParts = (): void => {
    // refetch();
    setShowSearchCatalogModal(true);
  };

  const handleDragOnHand = (result: any): void => {
    if (!result.destination) {
      return;
    }
    const listItems =
      type === 'Returning'
        ? [...inventoryDetail.lineItems]
        : [...inventoryDetail.receivedLineItems];
    const reorderedItem = listItems.splice(result.source.index, 1);
    listItems.splice(result.destination.index, 0, ...reorderedItem);
  };
  const updateProducts: Array<any> = items;
  const handleCount = (event: any, data: { value: string; number: number }, product: any): void => {
    setonChangeActive(true);
    const updatedList = [...items];
    updatedList.forEach((element: any) => {
      if (
        product.productId === element.productId &&
        product.usageExternalId === element.usageExternalId &&
        product.lotNumber === element.lotNumber
      ) {
        const packContent =
          element?.salesUnitOfMeasure === 'PK' || element?.salesUnitOfMeasure === 'BX';

        const packOfContentCount = product?.packContent > 0 ? product?.packContent || 1 : 1;

        if (data.value !== '' && data.number > 0) {
          const maxQty = data.number > element.maxQuantity ? element.maxQuantity : data.number;
          element.counterValue =
            element.iscatalog && data.number < MAX_QUANTITY
              ? data.number
              : data.number <= maxQty
              ? data.number
              : maxQty;
          if (
            userInfo?.businessunit === 'Sports Medicine' &&
            element.productFamily === 'SPTSIMPLANTS' &&
            packContent
          ) {
            element.actualQuantity = element.counterValue * packOfContentCount;
          } else {
            element.actualQuantity = element.counterValue;
          }
          element.changed = true;
          // element.previousQuantity =  element.quantity;
        } else {
          element.counterValue = '';
          element.changed = false;
        }
      }
    });
    setItems(updatedList);
    // handleUpdates();
    const debounceHandleCountalert = debounce(handleUpdates, 1000);
    debounceHandleCountalert();
  };
  const handleCountalert = (
    event: any,
    data: { value: string; number: number },
    product: any
  ): void => {
    if (product?.productOnHold) {
      openSnackBar(
        NOTIFY_TYPE.ERROR,
        'This Product/Lot/Serial is currently on hold. Remove this Product/Lot/Serial to advance this order.'
      );
    }
    handleCount(event, data, product);
  };
  const handleDelete = (product: any): void => {
    // empty/clear quantity, it will delete ib Backend
    let counter = 0;
    const listItems = [...items];
    listItems.forEach((i: any) => {
      if (
        i.productId === product.productId &&
        i.usageExternalId === product.usageExternalId &&
        product.lotNumber === i.lotNumber
      ) {
        i.counterValue = 0;
        i.changed = true;
        i.deleted = true;
      }
      counter += i.counterValue;
    });
    setItems(listItems || []);
    handleUpdates();
  };

  const handleSelectDropdownItem = (data: any, item: any): void => {
    // Catalog, Repstock, Customer
    const listItems = [...items];
    listItems.forEach((i: any) => {
      if (i.externalId === item) {
        i.changed = true;
        i.sourceLocation = data?.selection[0]?.value;
        //  i.lotNumber = '';
      }
    });
    setItems(listItems || []);
    handleUpdates();
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleSuggestionSelect = (suggestion: any, lineItem: any) => {
    setonChangeActive(true);
    const listItems = [...items].map((i: any) => {
      if (i.uniqueId === lineItem.uniqueId) {
        const product: any = items?.find(
          (value: any) =>
            value.lotNumber === i.lotNumber &&
            value.productNumber === i.productNumber &&
            value.externalId !== i.externalId &&
            value.sourceLocation === i.sourceLocation
        );

        if (product && product.iscatalog && !product.isValidLotSerialCombination) {
          product.isLotValueUpdated = true;
          product.caseUsageSubInventoryCode = lineItem.caseUsageSubInventoryCode;
        }

        return {
          ...i,
          previousLotNumber: i?.lotNumber?.trim(),
          isLotValueUpdated: i?.lotNumber?.trim() !== suggestion?.label?.trim(),
          lotNumber: suggestion?.label?.trim(),
          // caseUsageSubInventoryCode: Number(suggestion.availableqty)
          //   ? suggestion.subInventoryCode
          //   : '',
        };
      }
      return i;
    });
    setItems(listItems || []);
    setLotChange(1);
    setLoader(true);
    // saveParts(true);
    // handleAddParts()
  };

  const handleSelect = (event: any, data: any, id: string): void => {
    setonChangeActive(true);
    const listItems = items.map((i: any) => {
      if (i.uniqueId === id) {
        const product: any = items?.find(
          (value: any) =>
            (value.lotNumber === i.lotNumber ||
              value.lotNumber === data?.selection?.[0]?.lotNumber) &&
            value.productNumber === i.productNumber &&
            value.externalId !== i.externalId &&
            value.sourceLocation === i.sourceLocation
        );

        let maxQuantity = MAX_QUANTITY;
        const qty = i.quantity;
        const actualqty = i.actualQuantity;
        let newLotNumber = '';
        if (data.selection && data.selection[0]) {
          const { availableqty, lotNumber } = data.selection[0];
          if (lotNumber === i.lotNumber) {
            // Edit Same Lot
            maxQuantity = Number(availableqty) + Number(i.originalQty);
          } else {
            // Selected New Lot
            maxQuantity = Number(availableqty);
            newLotNumber = lotNumber;
            // qty = 0; // Initiate
            // actualqty = 0;
          }
        }
        if (product) {
          product.isLotValueUpdated = true;
          product.caseUsageSubInventoryCode = i.caseUsageSubInventoryCode;
        }
        if (
          inventoryDetail?.status === 'Failed' &&
          i?.iscatalog === true &&
          data.selection &&
          data.selection[0]
        ) {
          i.isLotValueUpdated = true;
        }
        return {
          ...i,
          lotNumber: newLotNumber,
          selectedLot: data.selection || [],
          previousLotNumber: i?.lotNumber?.trim(),
          maxQuantity,
          quantity: qty,
          actualQuantity: actualqty,
        };
      }
      return i;
    });

    setItems(listItems || []);
    setLotChange(1);
  };

  const handleSelectReturnType = (data: any, item: any): void => {
    const listItems = [...items];
    listItems.forEach((i: any) => {
      if (
        i.productId === item.productId &&
        i.usageExternalId === item.usageExternalId &&
        item.lotNumber === i.lotNumber
      ) {
        i.returnReason = data.selection;
        i.changed = true;
        i.sourceLocation = data?.selection[0]?.value;
        //  i.lotNumber = '';
      }
    });
    setItems(listItems || []);
    handleUpdates();
  };

  const handleTrackingNumber = (event: any, item: any): void => {
    const listItems = [...items];
    listItems.forEach((i: any) => {
      if (
        i.productId === item.productId &&
        i.usageExternalId === item.usageExternalId &&
        item.lotNumber === i.lotNumber
      ) {
        i.trackingNumber = event.target.value;
        i.changed = true;
      }
    });
    setItems(listItems || []);
    setLotChange(1);
    // handleUpdates();
  };
  const handleLotSerialNumber = (event: any, item: any): void => {
    const listItems = [...items];
    listItems.forEach((i: any) => {
      if (i.productId === item.productId && item.lotNumber === i.lotNumber) {
        i.lotNumber = event.target.value;
        i.changed = true;
      }
    });
    setItems(listItems || []);
    setLotChange(1);
  };

  const handleUserWorkflowAction = (changeItem: any): void => {
    const listItemsF = [...items];
    listItemsF.forEach((e: any) => {
      if (
        e.productId === changeItem.productId &&
        e.caseUsageExternalId === changeItem.caseUsageExternalId
      ) {
        e.quantity = 0;
        e.actualQuantity = 0;
        e.counterValue = 0;
        e.changed = true;
        e.deleted = true;
      }
    });
    setItems(listItemsF);
    handleUpdates();
  };

  const iconPath = getEventIcon(CYCLE_COUNT);

  const setSearch = (value: string): void => {
    setLoader(true);
    setSearchText(value);
    if (returnType === 'Processed' || returnType === 'Failed') {
      refetchProcessedEventDetails();
    } else refetchEventDetails();
  };

  const debouncedFetchRequestedItems = useCallback(debounced(500, setSearch), [
    debounced,
    setSearch,
  ]);

  const handleSearch = useCallback(
    (_event: { persist: () => void }, searchedItem: any) => {
      const { value } = searchedItem;
      _event.persist();
      debouncedFetchRequestedItems(value);
    },
    [debouncedFetchRequestedItems]
  );

  const headerActions = (): ReactNode => (
    <PageHeaderControl>
      <ButtonGroup variant="list" id="button-group-page-header-actions">
        <div style={{ marginRight: '10px' }}>
          <CartComponent
            count={quantityCount}
            color="grey"
            textColor="white"
            cartTitle="Returning"
          />
        </div>
        <div style={{ marginRight: '10px' }}>
          <CartComponent
            count={quantityRecCount}
            color="grey"
            textColor="white"
            cartTitle="Received"
          />
        </div>
        <Button
          iconCategory="utility"
          iconSize="small"
          className="slds-text-color_default"
          label="Add"
          iconName="add"
          iconPosition="left"
          disabled={
            isUserOpsCsr && returnType === 'Failed'
              ? false || viewOnly
              : visualIndicator.toLowerCase() === 'requested' ||
                visualIndicator.toLowerCase() === 'approved' ||
                visualIndicator.toLowerCase() === 'cancelled' ||
                visualIndicator.toLowerCase() === 'label requested' ||
                isOrder ||
                (isUserSalesRep && visualIndicator.toLowerCase() === '3pl review') ||
                (returnType === 'Failed' && !isUserOps)
          }
          style={{ fontWeight: 'bold' }}
          onClick={handleAddParts}
        />
      </ButtonGroup>
    </PageHeaderControl>
  );

  return (
    <IconSettings iconPath="/icons">
      <SnackBar open={open} notification={notification} />
      {(isLoading || loading || processedLoading || partsLoader || updateLoader) && <Spinner />}
      <PageHeader
        className="events_header"
        icon={
          <img
            src={iconPath}
            className="logo-image"
            alt="company"
            style={{ width: '2.75rem', height: '2.75rem' }}
          />
        }
        onRenderActions={headerActions}
        variant="record-home"
        title="Inventory"
      />
      {showSearchCatalogModal && (
        <InventoryAddParts
          isOpen={showSearchCatalogModal}
          handleClose={onHandleCloseSearchCatalogModal}
          inventoryReturnDetail={inventoryDetail}
          returnType={returnType}
          count={quantityCount}
        />
      )}
      <div className="order-list-container">
        <DragDropContext onDragEnd={handleDragOnHand}>
          <Droppable droppableId="items">
            {(provided: any): any =>
              type === 'Returning' ? (
                <div className="inventory-table-container">
                  <div className={`parts-table-header ${tableClass} `}>
                    {detailsViewConfig.includes('Part') && <p>Part</p>}
                    {detailsViewConfig.includes('Lot_Serial') && (
                      <p style={{ textAlign: 'left' }}>Lot/Serial</p>
                    )}

                    {detailsViewConfig.includes('Expiration') && (
                      <p style={{ textAlign: 'center' }}>Expiration Date</p>
                    )}
                    {detailsViewConfig.includes('Status') && (
                      <p style={{ textAlign: 'left', marginLeft: '25px' }}>Status</p>
                    )}
                    {detailsViewConfig.includes('Qty') && (
                      <p style={{ textAlign: 'center' }}>Qty</p>
                    )}
                    <p style={{ marginLeft: '13%' }}>Source Location</p>
                    {(!isPickupReturnType && detailsViewConfig.includes('tracking#')) ||
                    (!isPickupReturnType && detailsViewConfig.includes('Tracking')) ? (
                      <p style={{ textAlign: 'center' }}>Tracking #</p>
                    ) : (
                      ''
                    )}
                    {/* {detailsViewConfig.includes('Lot/Serial') && ( */}

                    <p style={{ textAlign: 'center' }}>Action</p>
                    {/* )} */}
                  </div>
                  {items?.length > 0 &&
                    items.map((lineItem: any) => {
                      return !lineItem.deleted ? (
                        <div className={`parts-table-header ${tableClass} `}>
                          {detailsViewConfig.includes('Part') && (
                            <div
                              style={{
                                paddingLeft: '5px',
                                textAlign: 'left',
                                fontWeight: 'bold',
                                overflow: 'hidden',
                                wordWrap: 'break-word',
                              }}
                              className={
                                !lineItem?.isValidLotSerialCombination &&
                                lineItem.iscatalog &&
                                inventoryDetail?.status !== 'Completed' &&
                                lineItem.lotValidation === 'true'
                                  ? 'redPart'
                                  : ''
                              }
                            >
                              {`${lineItem.productNumber} ${
                                isOrder || returnType === 'Failed'
                                  ? lineItem.productdescription || lineItem.productDescription || ''
                                  : lineItem.productDescription
                              }`}
                              {lineItem.productOnHold ? (
                                <img
                                  src={holdIconPath}
                                  className="logo-image"
                                  alt="company"
                                  style={{
                                    marginLeft: '10px',
                                    width: '16px',
                                    height: '17px',
                                  }}
                                />
                              ) : (
                                ''
                              )}
                              {lineItem?.iscatalog && (
                                <img
                                  src={catalogInd}
                                  className="slds-tooltip-trigger"
                                  alt="catalog part"
                                  style={{
                                    marginLeft: '25px',
                                    marginRight: '8px',
                                    cursor: 'default',
                                  }}
                                  title="This part was selected from the Catalog"
                                />
                              )}
                            </div>
                          )}
                          {detailsViewConfig.includes('Lot_Serial') && (
                            <div className="row-control-lot widthAdjust">
                              {(lineItem?.iscatalog &&
                                returnType !== 'Failed' &&
                                inventoryDetail?.status !== 'Failed') ||
                              (lineItem?.iscatalog &&
                                returnType === 'Failed' &&
                                inventoryDetail?.status !== 'Failed' &&
                                lineItem.lotValidation === 'false') ? (
                                // eslint-disable-next-line react/jsx-indent
                                <InputWithAutoSuggestion
                                  disabled={
                                    isUserOpsCsr && returnType === 'Failed'
                                      ? false || viewOnly
                                      : visualIndicator.toLowerCase() === 'requested' ||
                                        visualIndicator.toLowerCase() === 'approved' ||
                                        visualIndicator.toLowerCase() === 'cancelled' ||
                                        visualIndicator.toLowerCase() === 'label requested' ||
                                        isOrder ||
                                        (returnType === 'Failed' && !isUserOps)
                                  }
                                  lineItem={lineItem}
                                  handleSuggestionSelect={handleSuggestionSelect}
                                  forceUppercase={lineItem?.iscatalog}
                                />
                              ) : (
                                <Combobox
                                  disabled={
                                    isUserOpsCsr && returnType === 'Failed'
                                      ? false || viewOnly
                                      : visualIndicator.toLowerCase() === 'requested' ||
                                        visualIndicator.toLowerCase() === 'approved' ||
                                        visualIndicator.toLowerCase() === 'cancelled' ||
                                        visualIndicator.toLowerCase() === 'label requested' ||
                                        isOrder ||
                                        (returnType === 'Failed' && !isUserOps)
                                  }
                                  id="lotNumber"
                                  events={{
                                    onSelect: (event: any, data: any): void =>
                                      handleSelect(event, data, lineItem.uniqueId),
                                  }}
                                  labels={{
                                    placeholder: 'Select',
                                    noOptionsFound: 'No data found',
                                  }}
                                  placeholder="Select"
                                  options={
                                    lineItem.sourceLocation && lineItem?.lotOptions
                                      ? lineItem.lotOptions
                                      : []
                                  }
                                  selection={lineItem.selectedLot || []}
                                  variant="readonly"
                                />
                              )}
                            </div>
                          )}
                          {detailsViewConfig.includes('Expiration') && (
                            <div
                              style={{
                                paddingLeft: '5px',
                                textAlign: 'center',
                                fontWeight: 'bold',
                              }}
                            >
                              {lineItem.expirationDate
                                ? moment(lineItem.expirationDate).format('MM/DD/YYYY')
                                : '--'}
                            </div>
                          )}
                          {detailsViewConfig.includes('Status') && (
                            <div style={{ paddingLeft: '5px', display: 'flex' }}>
                              <EventStatusBadge
                                status={isOrder ? lineItem.status : lineItem.lineVisualIndicator}
                              />
                              <br />
                            </div>
                          )}
                          {detailsViewConfig.includes('Qty') && (
                            <div style={{ paddingLeft: '5px', textAlign: 'center' }}>
                              <div className="row-control">
                                <Input
                                  id="counter-input-3"
                                  minValue={1}
                                  maxValue={maxQuantityCals(
                                    lineItem,
                                    inventoryDetail,
                                    MAX_QUANTITY
                                  )}
                                  disabled={
                                    // (lineItem &&
                                    //   lineItem.lineVisualIndicator &&
                                    //   lineItem.lineVisualIndicator.toLowerCase() === 'approved') ||
                                    isUserOpsCsr && returnType === 'Failed'
                                      ? false || viewOnly
                                      : visualIndicator.toLowerCase() === 'requested' ||
                                        visualIndicator.toLowerCase() === 'approved' ||
                                        visualIndicator.toLowerCase() === 'cancelled' ||
                                        visualIndicator.toLowerCase() === 'label requested' ||
                                        isOrder ||
                                        (returnType === 'Failed' && !isUserOps)
                                  }
                                  onChange={(
                                    event: any,
                                    data: { value: string; number: number }
                                  ): void => {
                                    if (
                                      data.number >
                                      maxQuantityCals(lineItem, inventoryDetail, MAX_QUANTITY)
                                    ) {
                                      const qData = {
                                        value: maxQuantityCals(
                                          lineItem,
                                          inventoryDetail,
                                          MAX_QUANTITY
                                        ).toString(),
                                        number: maxQuantityCals(
                                          lineItem,
                                          inventoryDetail,
                                          MAX_QUANTITY
                                        ),
                                      };
                                      handleCountalert(event, qData, lineItem);
                                    } else {
                                      handleCountalert(event, data, lineItem);
                                    }
                                  }}
                                  value={lineItem.counterValue}
                                  variant="counter"
                                />
                              </div>
                            </div>
                          )}
                          <div className="row-control widthAuto">
                            {lineItem?.sourceLocation ? (
                              <div className="vertical-align-middle" style={{ marginLeft: '10%' }}>
                                {lineItem.sourceLocation}
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                          {(!isPickupReturnType && detailsViewConfig.includes('tracking#')) ||
                          (!isPickupReturnType && detailsViewConfig.includes('Tracking')) ? (
                            <div className="vertical-align-middle" style={{ paddingLeft: '10px' }}>
                              <Input
                                value={lineItem.trackingNumber ? lineItem.trackingNumber : ''}
                                onChange={(_event: any): void =>
                                  handleTrackingNumber(_event, lineItem)
                                }
                                autoComplete="off"
                                id="unique-id-4"
                                disabled={
                                  // (lineItem &&
                                  //   lineItem.lineVisualIndicator &&
                                  //   lineItem.lineVisualIndicator.toLowerCase() === 'approved') ||
                                  visualIndicator.toLowerCase() === 'requested' ||
                                  visualIndicator.toLowerCase() === 'submitted' ||
                                  visualIndicator.toLowerCase() === 'cancelled' ||
                                  visualIndicator.toLowerCase() === 'label requested' ||
                                  isOrder ||
                                  viewOnly ||
                                  (returnType === 'Failed' && !isUserOps)
                                }
                              />
                            </div>
                          ) : (
                            ''
                          )}
                          {/* {detailsViewConfig.includes('Lot/Serial') && ( */}
                          <div
                            className="vertical-align-middle"
                            style={{ paddingLeft: '5px', textAlign: 'center' }}
                          >
                            <Button
                              disabled={
                                isUserOpsCsr && returnType === 'Failed'
                                  ? false || viewOnly
                                  : visualIndicator.toLowerCase() === 'requested' ||
                                    // visualIndicator.toLowerCase() === 'approved' ||
                                    visualIndicator.toLowerCase() === 'cancelled' ||
                                    visualIndicator.toLowerCase() === 'submitted' ||
                                    isOrder ||
                                    viewOnly ||
                                    visualIndicator.toLowerCase() === 'label requested' ||
                                    (returnType === 'Failed' && !isUserOps)
                              }
                              iconCategory="utility"
                              iconName="delete"
                              iconSize="large"
                              iconVariant="bare"
                              variant="icon"
                              onClick={(): void => handleDelete(lineItem)}
                            />
                          </div>
                          {/* )} */}
                        </div>
                      ) : null;
                    })}
                </div>
              ) : (
                <div className="inventory-table-container">
                  <div className={`parts-table-header ${tableClass} `}>
                    <p>Part</p>
                    <p style={{ textAlign: 'left' }}>Lot/Serial</p>
                    {!isPickupReturnType && <p style={{ textAlign: 'center' }}>Expiration Date</p>}
                    {detailsViewConfig.includes('Status') && (
                      <p style={{ textAlign: 'left', marginLeft: '25px' }}>Status</p>
                    )}
                    {detailsViewConfig.includes('tracking#') ||
                      (detailsViewConfig.includes('Tracking') && (
                        <p style={{ textAlign: 'center' }}>Tracking #</p>
                      ))}
                    {detailsViewConfig.includes('Returning Qty') && (
                      <p style={{ textAlign: 'center' }}>Returning Qty</p>
                    )}
                    {detailsViewConfig.includes('Received_Qty') && (
                      <p style={{ textAlign: 'center' }}>Received Qty</p>
                    )}
                    {detailsViewConfig.includes('ERP_Order') && (
                      <p style={{ textAlign: 'center' }}>ERP Order</p>
                    )}
                    {detailsViewConfig.includes('Received') && (
                      <p style={{ textAlign: 'center' }}>Received</p>
                    )}
                  </div>
                  {items?.length > 0 &&
                    items.map((lineItem: any) => {
                      return !lineItem.deleted ? (
                        <div className={`parts-table-header ${tableClass} `}>
                          <div
                            style={{ paddingLeft: '5px', textAlign: 'left', fontWeight: 'bold' }}
                          >
                            {`${lineItem.productNumber} ${
                              isOrder || returnType === 'Failed'
                                ? lineItem.productdescription
                                : lineItem.productDescription
                            }`}
                            {lineItem.productOnHold ? (
                              <img
                                src={holdIconPath}
                                className="logo-image"
                                alt="company"
                                style={{ marginTop: '-36px', marginLeft: '57%' }}
                              />
                            ) : (
                              ''
                            )}
                            {lineItem?.iscatalog && (
                              <img
                                src={catalogInd}
                                className="slds-tooltip-trigger"
                                alt="catalog part"
                                style={{
                                  cursor: 'default',
                                }}
                                title="This part was selected from the Catalog"
                              />
                            )}
                            {lineItem?.failureReason && (
                              <span style={{ marginLeft: '10px' }} title={lineItem?.failureReason}>
                                <Icon
                                  category="utility"
                                  name="warning"
                                  size="x-small"
                                  style={{ fill: '#D2042D', marginRight: '5px' }}
                                />
                              </span>
                            )}
                            <br />
                          </div>

                          <div
                            style={{ paddingLeft: '5px', textAlign: 'left', fontWeight: 'bold' }}
                          >
                            {`${lineItem?.lotNumber || '--'}`}
                          </div>

                          {!isPickupReturnType && (
                            <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
                              {lineItem.expirationDate
                                ? moment(lineItem.expirationDate).format('MM/DD/YYYY')
                                : '--'}
                            </div>
                          )}

                          {detailsViewConfig.includes('Status') && (
                            <div style={{ textAlign: 'center' }}>
                              <EventStatusBadge
                                status={isOrder ? lineItem?.status : lineItem?.lineVisualIndicator}
                              />
                            </div>
                          )}
                          {detailsViewConfig.includes('tracking#') ||
                            (detailsViewConfig.includes('Tracking') && (
                              <div
                                className="vertical-align-middle"
                                style={{ paddingLeft: '10px' }}
                              >
                                <Input
                                  value={lineItem.trackingNumber ? lineItem.trackingNumber : ''}
                                  onChange={(_event: any): void =>
                                    handleTrackingNumber(_event, lineItem)
                                  }
                                  id="unique-id-4"
                                  disabled={
                                    visualIndicator.toLowerCase() === 'requested' ||
                                    visualIndicator.toLowerCase() === 'submitted' ||
                                    visualIndicator.toLowerCase() === 'cancelled' ||
                                    visualIndicator.toLowerCase() === 'label requested' ||
                                    isOrder ||
                                    viewOnly ||
                                    (returnType === 'Failed' && !isUserOps)
                                  }
                                />
                              </div>
                            ))}
                          {detailsViewConfig.includes('Returning Qty') && (
                            <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
                              {`${lineItem?.quantity || ''}`}
                            </div>
                          )}
                          {detailsViewConfig.includes('Received_Qty') && (
                            <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
                              {`${lineItem?.receivedQuantity || 0}`}
                            </div>
                          )}
                          {detailsViewConfig.includes('ERP_Order') && (
                            <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
                              {`${lineItem?.erpOrderNumber || ''}`}
                            </div>
                          )}
                          {detailsViewConfig.includes('Received') && (
                            <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
                              {lineItem?.receivedDate || '--'}
                            </div>
                          )}
                        </div>
                      ) : null;
                    })}
                </div>
              )
            }
          </Droppable>
        </DragDropContext>
      </div>
    </IconSettings>
  );
};

/** Custom Header on InventoryRequestDetailCatalog Page **/
export default InventoryRequestTable;
